// extracted by mini-css-extract-plugin
export var documentSearchContainer = "DocumentSearchInput-module--documentSearchContainer--2Xi2c";
export var searchIcon = "DocumentSearchInput-module--searchIcon--OMjCE";
export var searchInput = "DocumentSearchInput-module--searchInput--A1chD";
export var searchInputContainer = "DocumentSearchInput-module--searchInputContainer--Vadsc";